import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export const constantRoutes = [
    {path: '/',name: 'header',redirect:'/index?userid='+window.localStorage.getItem('userid'),component:()=>import('../views/header.vue'),children:[
		{path: '/index',name: 'index',component:()=>import('../views/index.vue')},//公司简介
		{path: '/guarantee',name: 'guarantee',component:()=>import('../views/guarantee.vue')},//保函查询
		{path: '/intention',name: 'intention',component:()=>import('../views/intention.vue')},//在线申请
		//{path: '/personCenter',name: 'personCenter',component:()=>import('../views/personCenter.vue')},//个人中心
	]},
]
const createRouter = () => new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

export function resetRouter () {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js